import Helpers from '@/lib/helpers';
import { DetailSection } from './DetailsSection';
import { Avatar } from 'antd';

export default function UserInfo({
  email,
  phone,
  countryCode,
  image,
  name,
  sectionTitle,
  loading,
}: {
  name: string;
  email: string;
  phone: string;
  image: string;
  countryCode?: string;
  sectionTitle: string;
  loading: boolean;
}) {
  console.log('eeeeeeeeeeeeee', image);

  return (
    <DetailSection isLoading={loading} title={sectionTitle}>
      <div className="flex justify-between items-center py-2">
        <div className="flex items-center gap-3">
          {!!image && (
            <Avatar src={image} size={48} className="shrink-0 bg-orange-100" />
          )}

          <div className="flex flex-col">
            <span className="text-gray-900 dark:text-gray-100 font-bold text-base">
              {name || '-'}
            </span>
            <span className="text-gray-500 dark:text-gray-400 text-sm">
              {email || '-'}
            </span>
          </div>
        </div>

        {phone && (
          <div className="flex items-center gap-x-1">
            <img
              src={`https://purecatamphetamine.github.io/country-flag-icons/3x2/${Helpers.getCountryCodeFromCallingCode(
                String(countryCode)
              )}.svg`}
              style={{ width: '20px', borderRadius: '2px' }}
            />

            <span>{phone}</span>
          </div>
        )}
      </div>
    </DetailSection>
  );
}
